import { useEffect, useState } from 'react';

import useDownloadFileContent from '@/pages/DataHub/Export/ExportPreview/useDownloadFileContent';
import { SelectedSymbol } from '@/types/symbols';

import { replacePlaceholders } from '../../utils/replacePlaceholders';

const usePowerQueryPreview = (
  capturePosthogEvent: () => void,
  exportApiUrl: string,
  symbols: Set<SelectedSymbol> | undefined
) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fileContent, setFileContent] = useState<string>('');

  const { downloadFileContent } = useDownloadFileContent(capturePosthogEvent);

  const downloadFile = () => {
    downloadFileContent(fileContent, 'txt');
  };

  useEffect(() => {
    getTextContent();
  }, [exportApiUrl]);

  const getTextContent = async () => {
    setLoading(true);
    setError(false);

    try {
      const results = await fetch('/export/examples/powerQuery_export_script_template.txt');
      const powerQueryScriptTemplate = await results.text();
      const url = exportApiUrl
        .split('&')
        .filter(str => !str.includes('metadata'))
        .join('&')
        .concat('&metadata=true');

      const rowFilters =
        symbols && symbols.size > 0
          ? Array.from(symbols)
              .map(
                symbol =>
                  `(Text.From([Code]) = "${symbol.Code}" and Text.From([TimeRef]) = "${symbol.TimeRef}" and Text.From([PeriodType]) = "${symbol.PeriodType}" and Text.From([Period]) = "${symbol.Period}")`
              )
              .join(' or \n')
          : '';

      const replacements = {
        apiUrl: url,
        rowFilters
      };
      setFileContent(replacePlaceholders(powerQueryScriptTemplate, replacements));
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, fileContent, downloadFile };
};

export default usePowerQueryPreview;
